<template>
  <div class="sr-text">
    <template v-if="!getTextModel">
      <el-popover
        :placement="item.placement || 'top-start'"
        :width="item.width || 400"
        :trigger="item.trigger || 'click'"
        popper-class="sr-text-popover"
      >
        <el-input
          type="textarea"
          resize="none"
          :rows="5"
          :placeholder="item.placeholder"
          v-model="value"
        ></el-input>
        <el-input
          v-model="value"
          placeholder="请输入"
          slot="reference"
        ></el-input>
      </el-popover>
    </template>
    <div v-else>
      {{ value }}
    </div>
  </div>
</template>

<script>
export default {
  name: "SrText",
  model: {
    prop: "value",
    event: "change",
  },
  props: ["value", "item", "formComConfig"],
  computed: {
    // 是否采用文字模式
    getTextModel() {
      if (undefined === this.item.isText || '' === this.item.isText) {
        // item没有设置是否纯文本显示，判断全局的textModel
        return this.formComConfig.textModel;
      } else {
        return this.item.isText;
      }
    },
  },
};
</script>


// WEBPACK FOOTER //
// packages/SrText/SrText.vue